import * as React from 'react';
import PropTypes from 'prop-types';

import SVGService from '../services/SVG';

/**
 * A React component for displaying a small map preview
 *
 * @class MapPreview
 * @extends {React.Component}
 */
class MapPreview extends React.Component {
    constructor(props) {
        super(props);

        // Set up ref for injecting SVG
        this.svgParent = React.createRef();
    }

    render () {
		return <div ref={this.svgParent} />;
    }

    componentDidMount () {
        // ?FIXME: Attaching map SVG as a DOM child?
        const map = SVGService.getSVGCloneByName(this.props.mapName);
        // Ensure map fills the container space
        if (map) {
          map.setAttribute("class", "full-width-height");
          map.setAttribute("id", this.props.mapName + "nav");
          this.svgParent.current.appendChild(
              map
          );
        }
    }
}

MapPreview.propTypes = {
	mapName: PropTypes.string.isRequired,
};

export default MapPreview;



// WEBPACK FOOTER //
// ./src/components/MapPreview.js